import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalOffering from "@/pages/ClinicalOffering";

export const Route = createFileRoute("/en/services/clinical-solutions/pmpf")({
  head: () => buildRouteHead("/en/services/clinical-solutions/pmpf"),
  component: ClinicalOffering,
});

